module.exports = __webpack_public_path__ + "img/icon_intrest_redpacket_banner.86c97914.png";